<template>
  <BaseModal v-model="show" title="APP更新" :width="360" :centered="true">
    <div v-if="loading">
      <div style="padding:20px 0;text-align:center;">
        <a-spin :tip="loadingText"/>
      </div>
    </div>
    <div v-else>
      <div v-html="description"/>
      <div class="buttons">
        <a-button type="default" @click="cancel">取消</a-button>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <a-button type="primary" @click="ensure">更新</a-button>
      </div>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/comps/BaseModal";

export default {
  name: "AppUpdate",
  components: {BaseModal},
  props: {
    loading: Boolean,
    loadingText: String,
    description: String,
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    open() {
      this.show = true;
    },
    cancel() {
      this.show = false;
    },
    ensure() {
      this.$emit("ensure");
    }
  }
}
</script>

<style scoped lang="less">
.buttons {
  padding-top: 20px;
  text-align: center;
}
</style>
